import { render, staticRenderFns } from "./manager.vue?vue&type=template&id=1585adcb&"
import script from "./manager.vue?vue&type=script&lang=ts&"
export * from "./manager.vue?vue&type=script&lang=ts&"
import style0 from "./manager.vue?vue&type=style&index=0&id=1585adcb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports